import React from "react";

export const StopFill: React.FC<any> = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    {...props}
  >
    <defs>
      <clipPath id="master_svg0_1041_167108/1041_143747/1087_89884">
        <rect x="0" y="0" width="24" height="24" rx="0" />
      </clipPath>
    </defs>
    <g clipPath="url(#master_svg0_1041_167108/1041_143747/1087_89884)">
      <g>
        <path
          d="M5.550000190734863,16.950000190734862L5.550000190734863,7.050000190734863C5.550000190734863,6.221573190734864,6.221573190734864,5.550000190734863,7.050000190734863,5.550000190734863L16.950000190734862,5.550000190734863C17.778400190734864,5.550000190734863,18.450000190734862,6.221573190734864,18.450000190734862,7.050000190734863L18.450000190734862,16.950000190734862C18.450000190734862,17.778400190734864,17.778400190734864,18.450000190734862,16.950000190734862,18.450000190734862L7.050000190734863,18.450000190734862C6.221573190734864,18.450000190734862,5.550000190734863,17.778400190734864,5.550000190734863,16.950000190734862Z"
          fill="currentColor"
          fillOpacity="1"
        />
      </g>
    </g>
  </svg>
);
